// import { createContext, useContext, useEffect, useState } from "react";
// import { useQuery } from "@tanstack/react-query";
// import { getUserById } from "../api/common";

// const LanguageContext = createContext(undefined);

// export const LanguageProvider = ({ children }) => {
//     const [language, setLanguage] = useState("English");

//     const { data: profileData, isLoading } = useQuery({
//         queryKey: ["userLanguage"],
//         queryFn: getUserById,
//         keepPreviousData: true,
//     });

//     const data = profileData?.data

//     useEffect(() => {

//         if (data?.language) {
//             setLanguage(data?.language);
//         } else {
//             setLanguage("English");
//         }

//     }, [data])

//     if (isLoading) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <LanguageContext.Provider value={{ language, setLanguage }}>
//             {children}
//         </LanguageContext.Provider>
//     );
// };

// export const useLanguage = () => {
//     const context = useContext(LanguageContext);
//     if (!context) {
//         throw new Error("useLanguage must be used within a LanguageProvider");
//     }
//     return context;
// };

// import { createContext, useContext, useEffect, useState } from "react";
// import { useQuery } from "@tanstack/react-query";
// import { getUserById } from "../api/common";

// const LanguageContext = createContext(undefined);

// export const LanguageProvider = ({ children }) => {
//     const [language, setLanguage] = useState("English");

//     const { data: profileData } = useQuery({
//         queryKey: ["userLanguage"],
//         queryFn: getUserById,
//         keepPreviousData: true,
//     });

//     const data = profileData?.data;

//     useEffect(() => {
//         if (data?.language) {
//             setLanguage(data.language);
//         }
//     }, [data]);

//     return (
//         <LanguageContext.Provider value={{ language, setLanguage }}>
//             {children}
//         </LanguageContext.Provider>
//     );
// };

// export const useLanguage = () => {
//     const context = useContext(LanguageContext);
//     if (!context) {
//         throw new Error("useLanguage must be used within a LanguageProvider");
//     }
//     return context;
// };

// import { createContext, useContext, useEffect, useState } from "react";
// import { useQuery } from "@tanstack/react-query";
// import { getUserById } from "../api/common";

// const LanguageContext = createContext(undefined);

// export const LanguageProvider = ({ children }) => {
//     const [language, setLanguage] = useState("English");

//     const { data: profileData } = useQuery({
//         queryKey: ["userLanguage"],
//         queryFn: getUserById,
//         keepPreviousData: true,
//     });

//     const data = profileData?.data;

//     useEffect(() => {
//         if (data?.language) {
//             setLanguage(data.language);
//         }
//     }, [data]);

//     return (
//         <LanguageContext.Provider value={{ language, setLanguage }}>
//             {children}
//         </LanguageContext.Provider>
//     );
// };

// export const useLanguage = () => {
//     const context = useContext(LanguageContext);
//     if (!context) {
//         throw new Error("useLanguage must be used within a LanguageProvider");
//     }
//     return context;
// };

import { createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getUserById } from "../api/common";

const VALID_LANGUAGES = ["English", "Georgian", "Russian"];

const LanguageContext = createContext(undefined);

// Helper function to get initial language from localStorage
const getInitialLanguage = () => {
  if (typeof window === "undefined") return "English"; // SSR fallback
  
  const savedLanguage = localStorage.getItem("language");
  if (VALID_LANGUAGES.includes(savedLanguage)) {
    return savedLanguage;
  }
  return "English"; // Default fallback
};

export const LanguageProvider = ({ children }) => {
  // Initialize language directly from localStorage for immediate availability
  const [language, setLanguage] = useState(() => getInitialLanguage());
  const [hadStoredPreference, setHadStoredPreference] = useState(() => {
    if (typeof window === "undefined") return false;
    const savedLanguage = localStorage.getItem("language");
    return VALID_LANGUAGES.includes(savedLanguage);
  });

  const { data: profileData } = useQuery({
    queryKey: ["userLanguage"],
    queryFn: getUserById,
    keepPreviousData: true,
  });

  const userLanguage = profileData?.data?.language;

  const isValidLanguage = (lang) => VALID_LANGUAGES.includes(lang);

  // Update language from user profile if available and no stored preference
  useEffect(() => {
    if (!userLanguage || !isValidLanguage(userLanguage)) return;
    if (hadStoredPreference) return;

    setLanguage(userLanguage);
    setHadStoredPreference(false);
  }, [userLanguage, hadStoredPreference]);

  // Persist language to localStorage whenever it changes
  useEffect(() => {
    if (language && isValidLanguage(language)) {
      localStorage.setItem("language", language);
      setHadStoredPreference(true);
    }
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
